import listVisitForClient from '@/graphql/check/listVisitForClient.gql';
import { query } from '@/services/GraphqlService';
import listVisit from '@/graphql/check/listVisit.gql';

export const getVisitListForClient = (apollo, variables) =>
  query(apollo, listVisitForClient, variables);

export const getVisitList = (apollo, variables) => query(apollo, listVisit, variables);
